import moment from 'moment'
import marked from 'marked'

export default {
    time: function (value) {
        let secondDelta = moment().diff(moment(value), 'seconds')

        if (secondDelta < 60) {
            return "刚刚"
        } else if (secondDelta < 3600) {
            return parseInt(secondDelta / 60) + "分钟前"
        } else if (secondDelta < 3600 * 24) {
            return parseInt(secondDelta / 3600) + "小时前"
        } else if (secondDelta < 3600 * 24 * 30) {
            return parseInt(secondDelta / 3600 / 24) + "天前"
        } else if (secondDelta < 3600 * 24 * 365) {
            return parseInt(secondDelta / 3600 / 24 / 30) + "个月前"
        } else {
            return parseInt(secondDelta / 3600 / 24 / 365) + "年前"
        }
    },

    date: function (value) {
        return moment(value).format('YYYY-MM-DD')
    },

    simpleDate: function (value) {
        return moment(value).format('MM月DD日')
    },

    quizTitle: function (quizResult, rank) {
        let correctness = quizResult.get('correctness')

        if (rank == 1 && correctness >= 0.8) {
            return "状元"
        } else if (rank == 2 && correctness >= 0.8) {
            return "榜眼"
        } else if (rank == 3 && correctness >= 0.8) {
            return "探花"
        } else if (correctness >= 0.7) {
            return "进士"
        } else if (correctness >= 0.6) {
            return "举人"
        } else {
            return "考生"
        }
    },

    markdown: function (text) {
        return marked(text.replace(/\n/g, '\n\n'))
    },

    highlightKeyAndMarkdown: function (text) {
        let paras = text.split('\n')
        let result = paras.map((para) => {
            return para.replace(/^([^：]+)：/g, '**$1：**')
        }).join('\n\n')

        return marked(result)
    },

    birthAndDeathYear: function (author) {
        var birthYear = author.get('birthYear')
        var deathYear = author.get('deathYear')

        if (birthYear && birthYear.indexOf('?') < 0) {
            birthYear += "年"
        }
        if (birthYear.indexOf('-') >= 0) {
            birthYear = birthYear.replace('-', '前')
        }

        if (deathYear && deathYear.indexOf('?') < 0) {
            deathYear += "年"
        }
        if (deathYear.indexOf('-') >= 0) {
            deathYear = deathYear.replace('-', '前')
        }

        return birthYear + " ~ " + deathYear
    },

    firstSentence: function (text) {
        text = text.replace(/\r\n/g, '');
        var match = text.match(/([^。？！；]+[。？！；]).*/);
        var result;

        if (!match || match.length < 2) {
            result = text;
        } else {
            result = match[1];
        }

        return result
    },

    processImage(imageUrl, width) {
        if (imageUrl.indexOf('lcfile.xichuangzhu.com') >= 0 || imageUrl.indexOf('httpcdn.xichuangzhu.com') >= 0 || imageUrl.indexOf('httpscdn.xichuangzhu.com') >= 0) {
            return `${imageUrl}?imageView2/2/w/${width * 2}`
        } else if (imageUrl.indexOf('static.xichuangzhu.com') >= 0) {
            return `${imageUrl}?x-oss-process=image/resize,w_${width * 2}/quality,Q_90`
        } else {
            return imageUrl
        }
    }
}



// WEBPACK FOOTER //
// ./src/filters.js